import {
    getData,
} from './Services'

export const getPoliticas = async () => {
    const res = await getData('/politicas/politicas_select');
    return res
}

export const getPoliticaById = async (id) => {
    const res = await getData(`/politicas/${id}`)
    return res
}